import retroImg from '@/assets/images/retro-category.png'
import newJerseyImg from '@/assets/images/new-shirt-category.png'

export default [
    {
        name: 'Ретро-джерси',
        label: 'Винтажные вещи для коллекции',
        image: retroImg
    },
    {
        name: 'С навесной биркой',
        label: 'Уникальные варианты в идеальном состоянии',
        image: newJerseyImg
    }
]